// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"859adf76","455":"6c16f634"}[chunkId] + ".chunk.js";
};